import axios from "axios";

export default axios.create({
  baseURL: "https://bartapi.dantechops.com/api",
  headers: {
    "Content-type": "application/json"
  }

  
});